import { WalletMoney, PercentageCircle, Building4, ClipboardText, Cpu, Code1, People, More, MoneySend, Briefcase, Monitor, Buildings, Airplane } from "iconsax-react";

export const SECTION_COLOR_MAP: Record<string, { fill: string; subtle: string; activeBorder: string }> = {
  direct: { fill: "viz-categorical-04-fill", subtle: "viz-categorical-04-subtle", activeBorder: "border-pink-500 dark:border-pink-300" },
  admin: { fill: "surface-info-fill", subtle: "surface-info-subtle", activeBorder: "border-blue-500 dark:border-blue-400" },
  mto: { fill: "surface-positive-fill", subtle: "surface-positive-subtle", activeBorder: "border-green-500 dark:border-green-400" },
} as const;

export const SUBCATEGORY_COLOR_MAP: Record<string, { fill: string; subtle: string }> = {
  salary: { fill: "surface-brand-fill", subtle: "surface-brand-subtle" },
  taxes: { fill: "surface-notice-fill", subtle: "surface-notice-subtle" },
  rental: { fill: "surface-info-fill", subtle: "surface-info-subtle" },
  supplies: { fill: "viz-categorical-04-fill", subtle: "viz-categorical-04-subtle" },
  equipment: { fill: "surface-positive-fill", subtle: "surface-positive-subtle" },
  software: { fill: "viz-categorical-01-fill", subtle: "viz-categorical-01-subtle" },
  contractors: { fill: "viz-categorical-04-fill", subtle: "viz-categorical-04-subtle" },
  msb_services: { fill: "viz-categorical-02-fill", subtle: "viz-categorical-02-subtle" },
  other_services: { fill: "surface-positive-fill", subtle: "surface-positive-subtle" },
  travel: { fill: "bg-brown-500", subtle: "bg-brown-100" },
} as const;

const SECTION_HEX_MAP: Record<string, string> = {
  direct: "#EC4899",
  admin: "#3B82F6",
  mto: "#22C55E",
} as const;

const SUBCATEGORY_HEX_MAP: Record<string, string> = {
  salary: "#33b4bd",
  taxes: "#F97316",
  rental: "#3B82F6",
  supplies: "#EC4899",
  equipment: "#22C55E",
  software: "#EAB308",
  contractors: "#EC4899",
  msb_services: "#6366F1",
  other_services: "#22C55E",
  travel: "#A67959",
} as const;

const HEX_PALETTE = [
  "#EAB308", "#3B82F6", "#22C55E", "#EC4899", "#33b4bd", "#F97316",
];

export function getSectionColorHex(sectionId: string): string {
  return SECTION_HEX_MAP[sectionId] || "#F97316";
}

export function getSubcategoryColorHex(subcategoryId: string, index: number): string {
  if (SUBCATEGORY_HEX_MAP[subcategoryId]) return SUBCATEGORY_HEX_MAP[subcategoryId];
  return HEX_PALETTE[index % HEX_PALETTE.length];
}

const DEFAULT_COLOR = { fill: "viz-categorical-06-fill", subtle: "viz-categorical-06-subtle", activeBorder: "border-orange-500 dark:border-orange-400" };

const FALLBACK_PALETTE = [
  { fill: "viz-categorical-01-fill", subtle: "viz-categorical-01-subtle" },
  { fill: "viz-categorical-02-fill", subtle: "viz-categorical-02-subtle" },
  { fill: "viz-categorical-03-fill", subtle: "viz-categorical-03-subtle" },
  { fill: "viz-categorical-04-fill", subtle: "viz-categorical-04-subtle" },
  { fill: "viz-categorical-05-fill", subtle: "viz-categorical-05-subtle" },
  { fill: "viz-categorical-06-fill", subtle: "viz-categorical-06-subtle" },
];

export function getSectionColorClasses(sectionId: string): { fill: string; subtle: string; activeBorder: string } {
  return SECTION_COLOR_MAP[sectionId] || DEFAULT_COLOR;
}

export function getSubcategoryColorClasses(subcategoryId: string, index: number): { fill: string; subtle: string } {
  if (SUBCATEGORY_COLOR_MAP[subcategoryId]) return SUBCATEGORY_COLOR_MAP[subcategoryId];
  return FALLBACK_PALETTE[index % FALLBACK_PALETTE.length];
}

export const SUBCATEGORY_ICONS: Record<string, typeof WalletMoney> = {
  salary: WalletMoney,
  taxes: PercentageCircle,
  rental: Building4,
  supplies: ClipboardText,
  equipment: Cpu,
  software: Code1,
  contractors: People,
  msb_services: Buildings,
  other_services: More,
  travel: Airplane,
} as const;

export const SECTION_ICONS: Record<string, typeof MoneySend> = {
  direct: MoneySend,
  admin: Briefcase,
  mto: Monitor,
} as const;

export const PERIOD_OPTION_KEYS = [
  { value: "today", labelKey: "period.today" },
  { value: "week", labelKey: "period.week" },
  { value: "month", labelKey: "period.month" },
  { value: "quarter", labelKey: "period.quarter" },
  { value: "halfYear", labelKey: "period.halfYear" },
  { value: "year", labelKey: "period.year" },
] as const;
